import { convertUtcToLocal } from "../../utils/functions";

export const CRealtimeCommonColumns = [
    {
      Header: "REQUEST TIME",
      accessor: "created_at",
      sort: false,
      Cell: ({ row }: any) =>
        `${convertUtcToLocal(row.original.created_at, "DD/MM/YYYY HH:mm:ss")}`,
    },
    {
      Header: "USER ID",
      accessor: "uuid",
      sort: false,
      Cell: ({ row }: any) =>
        `${
          row.original.uuid
            ? row.original.uuid.split(".").length > 1
              ? row.original.uuid.split(".")[1]
              : row.original.uuid.split(".")[0]
            : ""
        }`,
    },
    {
      Header: "COUNTRY",
      accessor: "country",
      sort: false,
    },
    {
      Header: "IPv4 Address",
      accessor: "ipv4",
      sort: false,
    },
    {
      Header: "IPv6 Address",
      accessor: "ipv6",
      sort: false,
    },
    {
      Header: "User Agent",
      accessor: "user_agent",
      sort: false,
    },
    {
      Header: "SHA1",
      accessor: "dpidsha1",
      sort: false,
    },
    {
      Header: "DOMAIN",
      accessor: "domain",
      sort: false,
    },
    {
      Header: "BUNDLE",
      accessor: "app_bundle",
      sort: false,
    },
  ];
  
  